
  import React from "react"
  import Component from "/home/ctlee/Development/adam-and-casey/src/layouts/index.js"
  import data from "/home/ctlee/Development/adam-and-casey/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js